module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pages-inner"
  }, [_c('Loader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }]
  }), (_vm.props && !_vm.loading) ? _c('div', {
    staticClass: "pages-content"
  }, [_c('Header'), _c('div', {
    staticClass: "main_content"
  }, [_c('div', {
    staticClass: "heroslider"
  }, [(_vm.props.better_featured_image) ? _c('div', {
    staticClass: "heroslide",
    style: ({
      backgroundImage: 'url(' + _vm.props.better_featured_image.source_url + ')'
    })
  }, [_c('div', {
    staticClass: "herooverlay"
  })]) : _vm._e(), _c('div', {
    staticClass: "heroslidecaptions perfecttreatment"
  }, [_c('div', {
    staticClass: "manual_container"
  }, [_c('div', {
    staticClass: "herotitle"
  }, [(_vm.props.title.rendered) ? _c('h2', {
    domProps: {
      "innerHTML": _vm._s(_vm.props.title.rendered)
    }
  }) : _vm._e()])])])]), _c('div', {
    staticClass: "newpatient_section"
  }, [_c('div', {
    staticClass: "manual_container"
  }, [(_vm.props.title.rendered) ? _c('h2', {
    domProps: {
      "innerHTML": _vm._s(_vm.props.title.rendered)
    }
  }) : _vm._e(), _c('div', {
    staticClass: "hero_divider"
  }, [(_vm.propsdividerhead.acf.grey_divider_img) ? _c('img', {
    attrs: {
      "src": _vm.propsdividerhead.acf.grey_divider_img,
      "alt": ""
    }
  }) : _vm._e()]), (_vm.props.content.rendered) ? _c('div', {
    staticClass: "intronewpatient",
    domProps: {
      "innerHTML": _vm._s(_vm.props.content.rendered)
    }
  }) : _vm._e()])])]), _c('Footer')], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-08dde598","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/pages/thank-you/thank-you.pug
// module id = 816
// module chunks = 1